import React, { useRef } from 'react';
import './InputField.css';

interface InputFieldProps {
  type?: 'text' | 'email' | 'password' | 'number';
  value?: string;
  onChange?: (value: string) => void;
  className?: string;
  disabled?: boolean;
  label?: string;
  maxLength?: number;
}

const InputField: React.FC<InputFieldProps> = ({
  type = 'text',
  value = '',
  onChange,
  className = '',
  disabled = false,
  label = '',
  maxLength,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let inputValue = e.target.value;

    // Restrict non-number characters only if input type is number
    if (type === 'number') {
      inputValue = inputValue.replace(/[^0-9]/g, '');
    }

    if (maxLength !== undefined) {
      inputValue = inputValue.slice(0, maxLength);
    }

    onChange?.(inputValue);
  };

  return (
    <div className={`group ${className}`}>
      <input
        ref={inputRef}
        type={type}
        value={value}
        onChange={handleChange}
        onKeyDown={(e) => {
          if (type === 'number' && ['e', 'E', '+', '-', '.'].includes(e.key)) {
            e.preventDefault();
          }
        }}
        disabled={disabled}
        required
        placeholder={label} // Use label as placeholder
        maxLength={type === 'number' ? undefined : maxLength}
        inputMode={type === 'number' ? 'numeric' : undefined}
      />
    </div>
  );
};

export default InputField;
